export const CheckMarkIcon = ({ color = 'white', width = 32, height = 26 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 32 26"
      fill="none"
    >
      <path
        d="M28.1761 0.473965L10.3359 19.1264L3.82385 12.247C3.48468 11.9633 2.94201 11.9633 2.67068 12.247L0.703501 14.3038C0.432166 14.5874 0.432166 15.1548 0.703501 15.5094L9.79322 24.9421C10.1324 25.2967 10.6072 25.2967 10.9464 24.9421L31.2965 3.66545C31.5678 3.38177 31.5678 2.81439 31.2965 2.45978L29.3293 0.473965C29.058 0.119355 28.5153 0.119355 28.1761 0.473965Z"
        fill={color}
      />
    </svg>
  );
};
